<template>
  <div class="shares-page page">
    <BreadcrumbsComponent @back.prevent :links="links" />
    <div class="shares-page__container sides-padding">
      <div ref="sharesList" class="shares-page__content">
        <div v-if="showShares" class="shares-page__items">
          <EntityCardComponent v-for="(item, i) in shares.data" :key="i" :item="item" :is-share="true" />
        </div>
        <span v-else>Акции отсутствуют</span>
        <PaginationComponent
          v-if="showPagination"
          :page="page"
          :total="Math.ceil(shares.paginatorInfo.total / first)"
          @change="paginate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "components/Pagination.vue";
import SHARES_PAGE from "@/graphql/pages/SharesPage.graphql";
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import EntityCardComponent from "components/EntityCardComponent.vue";

export default {
  name: "SharesPage",
  async asyncData({ apollo, store }) {
    await apollo.defaultClient
      .query({
        query: SHARES_PAGE,
        variables: {
          first: store.state.isMobile ? 4 : 5,
        },
      })
      .then(({ data }) => {
        store.state.shares_page.shares = data.shares_paginate;
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      });
  },
  data() {
    return {
      page: 1,
      first: this.$store.state.isMobile ? 4 : 5,
      paginateLoading: false,
    };
  },
  computed: {
    links() {
      return [{ title: "Акции" }];
    },
    shares() {
      return this.$store.state.shares_page.shares;
    },
    showShares() {
      return this.shares && this.shares.data && this.shares.data.length;
    },
    showPagination() {
      return this.showShares && Math.ceil(this.shares.paginatorInfo.total / this.first) > 1;
    },
  },
  methods: {
    async paginate(page) {
      if (!this.paginateLoading) {
        this.page = page;
        this.paginateLoading = true;
        await this.load();
        this.scrollUp();
      }
    },
    async load() {
      await this.$apollo.provider.defaultClient
        .query({
          query: SHARES_PAGE,
          variables: {
            page: this.page,
            first: this.first,
          },
        })
        .then(({ data }) => {
          this.paginateLoading = false;
          this.$store.state.shares_page.shares = data.shares_paginate;
          this.$store.state.categories = data.categories;
        })
        .catch(() => {
          this.filterLoading = false;
          this.paginateLoading = false;
        });
    },
    scrollUp() {
      if (window.scrollY > this.$refs.sharesList.offsetTop) {
        window.scrollTo({ top: this.$refs.sharesList.offsetTop });
      }
    },
  },
  components: {
    EntityCardComponent,
    BreadcrumbsComponent,
    PaginationComponent,
  },
  metaInfo: {
    title: "Акции",
  },
};
</script>

<style lang="stylus">
.shares-page {
  width 100%
  display grid
  grid-gap 32px
  padding-top 32px
  padding-bottom 48px
  +below(420px) {
    grid-gap 16px
  }

  &__content {
    display grid
    grid-gap 32px
    width 100%
    max-width var(--main_width)
  }

  &__items {
    display flex
    flex-wrap wrap
    grid-gap 30px
  }

  &__container {
    display flex
    justify-content center
  }
}
</style>
